
import { throwError as observableThrowError,  Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { AwsTracker, Level, GtmEvents, UserDetails, EventDetails } from './aws-tracker';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApplicationService } from '../../application/application.service';
import { SessionStorageService } from 'ngx-webstorage';
import { TokenService } from '../../token/token.service';
import { UUID } from 'angular2-uuid';
import { LoginService } from 'app/login/login.service';

declare var window: any;
// declare var mixpanel: any;

const enum Channel {
  default = 'default',
  widget = 'widget',
  partner_checkout = 'partner_checkout'
}

@Injectable()
export class AwsTrackingService {

  private funnelTrackingUrl = '/funneltrack';
  private widgetFlow = false;

  constructor(private http: HttpClient, private locationStrategy: LocationStrategy, private sessionStorage: SessionStorageService, private applicationService: ApplicationService, private tokenService: TokenService,  private loginService: LoginService) {}

  sendData(tracker: AwsTracker, applicationId: string, customerId: string = environment.dummyUuid): Observable<any> {
    tracker.EndTime = (new Date().getTime() / 1000);
    if (tracker.Type === Level.Page || tracker.Type === Level.Window) {
      tracker.Value = this.locationStrategy.getBaseHref() + '_page';
    }
    let str = '';
    for (const key in tracker) {
      if (tracker.hasOwnProperty(key)) {
        if (str !== '') {
          str += '&';
        }
        str += key + '=' + encodeURIComponent(tracker[key]);
      }
    }
    let url = environment.awsUrl + '?ApplicationId=' + applicationId;
    url = url + '&CustomerId=' + customerId;
    url = url + '&' + str;
    return this.http.get(url);
  }
  private getEventCategory(eventCategory?: string) {
    if (!eventCategory || eventCategory.length === 0) {
      eventCategory = 'XPE';
      if (this.applicationService.getApplication()) {
        eventCategory = 'Checkout';
      }
    }
    return eventCategory;
  }
  gtmPageLoadEvent(eventAction: string, eventCategory?: string) {
    let dataLayer = window['dataLayer'] || [];
    const data = {
      'eventCategory': this.getEventCategory(eventCategory),
      'eventAction': eventAction + this.checkForSuperPrimeCustomer(),
      'event': GtmEvents.PageLoad,
      'merchantName': this.applicationService.getApplication() ? this.applicationService.getApplication().MerchantName : 'PreEnrolMerchant',
      'userId': this.tokenService.getCustomerId(),
      'merchantUrl': window.location.ancestorOrigins,
    };
    if (this.checkWidget()) {
      const widgetDetails = this.tokenService.getDatafromPartnerSession() ? this.tokenService.getDatafromPartnerSession() : {};
      Object.assign(data, widgetDetails);
    }
    if (dataLayer.length > 0) {
      dataLayer.push(data);
    } else {
      setTimeout(fn => {
        dataLayer = window['dataLayer'] || [];
        dataLayer.push(data);
      }, 1000);
    }
  }
  gtmTriggerEvent(eventAction: string, eventCategory?: string) {
    const dataLayer = window['dataLayer'] || [];
    const data = {
      'eventCategory': this.getEventCategory(eventCategory),
      'eventAction': eventAction + this.checkForSuperPrimeCustomer(),
      'event': GtmEvents.GtmTrigger,
      'merchantName': this.applicationService.getApplication() ? this.applicationService.getApplication().MerchantName : 'PreEnrolMerchant',
      'userId': this.tokenService.getCustomerId(),
      'merchantUrl': window.location.ancestorOrigins,
    };
    if (this.checkWidget()) {
      const widgetDetails = this.tokenService.getDatafromPartnerSession() ? this.tokenService.getDatafromPartnerSession() : {};
      Object.assign(data, widgetDetails);
    }
    dataLayer.push(data);
  }
  gtmTriggerEventWithCustomCategoryAndData(eventAction: string, eventCategory: string, customData: any) {
    const dataLayer = window['dataLayer'] || [];
    const data = {
      'eventCategory': this.getEventCategory(eventCategory),
      'eventAction': eventAction + this.checkForSuperPrimeCustomer(),
      'event': GtmEvents.GtmTrigger,
      'merchantName': this.applicationService.getApplication() ? this.applicationService.getApplication().MerchantName : 'PreEnrolMerchant',
      'userId': this.tokenService.getCustomerId(),
      'merchantUrl': window.location.ancestorOrigins,
      ...customData
    };
    if (this.checkWidget()) {
      const widgetDetails = this.tokenService.getDatafromPartnerSession() ? this.tokenService.getDatafromPartnerSession() : {};
      Object.assign(data, widgetDetails);
    }
    dataLayer.push(data);
  }
  generateAndUpdateUUID(sessionUUID?: string) {
    const params = this.tokenService.getGlobalParams();
    if (!params || (params && (!params.SessionId || params.SessionId === environment.dummyUuid))) {
      const uuid = sessionUUID ? sessionUUID : UUID.UUID();
      this.tokenService.updateAndSetGlobalParams('SessionId', uuid);
    }
  }

  funnelInformation(eventDetails: EventDetails, isValid: boolean) {
    eventDetails.EventName = (isValid) ? eventDetails.EventName : eventDetails.EventName + '_invalid';
    this.sendDataToFunnel(eventDetails).subscribe();
  }

  sendDataToFunnel(eventDetails: EventDetails, creditValue = null): Observable<any> {
    const url = environment.funnelBaseUrl + this.funnelTrackingUrl;
    const merchantId = this.getMerchantId();
    const merchantName = this.sessionStorage.retrieve('zest-mconfig') ? this.sessionStorage.retrieve('zest-mconfig').MerchantName as string : null;
    const userDetails = new UserDetails(this.tokenService.getCustomerId(), this.applicationService.getApplicationId(), merchantId, merchantName);
    this.generateAndUpdateUUID();
    const globalParams = this.tokenService.getGlobalParams();
    const data = { ...eventDetails, ...userDetails, ...globalParams };
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    // if (window.mixpanel) {
    //  this.sendFunnelEventToMixPanel(data, creditValue);
    // }
    return this.http.post(url, data, { headers }).pipe(catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  getMerchantId() {
    let checkoutMerchantId = '';
    const checkoutParams = this.tokenService.getCheckoutParams();
    if (checkoutParams) {
      if (checkoutParams.merchantID) {
        checkoutMerchantId = checkoutParams.merchantID;
      } else if (checkoutParams.partnerId) {
        checkoutMerchantId = checkoutParams.partnerId;
      }
      return checkoutMerchantId;
    } else if (this.applicationService.getApplication()) {
      return this.applicationService.getMerchantId();
    } else if (this.applicationService.getPreapproveStates()) {
      return this.applicationService.getPreapproveStates().customer.merchantId;
    }
    return environment.zestMerchantId;
  }

  sendDataToGCFunnel(eventDetails: EventDetails, userInfo: UserDetails): Observable<any> {
    const url = environment.funnelBaseUrl + this.funnelTrackingUrl;
    const userDetails = new UserDetails(userInfo.CustomerId, this.applicationService.getApplicationId(), userInfo.MerchantId, userInfo.MerchantName);
    this.generateAndUpdateUUID();
    const globalParams = this.tokenService.getGlobalParams();
    const data = { ...eventDetails, ...userDetails, ...globalParams };
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    return this.http.post(url, data, { headers }).pipe(catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  checkForSuperPrimeCustomer() {
    const states = this.applicationService.getPreapproveStates();
    return (states && states.customer.customerType === 'Superprime') ? '-superprime' : '';

  }

  // sendFunnelEventToMixPanel(data, creditValue = null) {
  //  mixpanel.track(
  //    data.EventName,
  //    {
  //      ...data,
  //      creditValue
  //    }
  //  );
  // }

  sendDataToFunnelWithCustomProperties(eventDetails: EventDetails, customEventProperties: Object = {}): Observable<any> {
    const url = environment.funnelBaseUrl + this.funnelTrackingUrl;
    const merchantId = this.getMerchantId();
    const merchantName = this.sessionStorage.retrieve('zest-mconfig') ? this.sessionStorage.retrieve('zest-mconfig').MerchantName as string : null;
    const userDetails = new UserDetails(this.tokenService.getCustomerId(), this.applicationService.getApplicationId(), merchantId, merchantName);
    this.generateAndUpdateUUID();
    const globalParams = this.tokenService.getGlobalParams();
    const data = { ...eventDetails, ...userDetails, ...globalParams };
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    // if (window.mixpanel) {
    //  this.sendFunnelEventToMixPanel({...data, ...customEventProperties});
    // }
    return this.http.post(url, data, { headers }).pipe(catchError((error: any) => {
      return observableThrowError(error || 'Server error');
    }));
  }

  // trackMoengageEvent = (eventName: string) => {
  //  const moengage = window.Moengage;
  //  if ( moengage ) {
  //    moengage.track_event(eventName);
  //  }
  // }
  // setMoengageUserProperties = (fieldName: string, value: string) => {
  //  const moengage = window.Moengage;
  //  if ( moengage ) {
  //    moengage.add_user_attribute(fieldName , value );
  //  }
  // }

  checkWidget() {
    const partnerUrls = environment.partnerCheckoutUrl.length ? environment.partnerCheckoutUrl : [];
    return (window.location.ancestorOrigins &&  partnerUrls.some(r => Array.prototype.slice.call(window.location.ancestorOrigins).indexOf(r) >= 0)) && this.loginService.inIframe();
  }

  setGlobalCustomProps() {
    this.widgetFlow = this.checkWidget();
    const MerchantName = this.applicationService.getApplication() ? this.applicationService.getApplication().MerchantName : '';
    const Amount = this.applicationService.getApplication() ? this.applicationService.getApplication().BasketAmount : '';
    const Tenure = this.applicationService.getApplication() ? this.applicationService.getApplication().NumberOfInstallments : '';
    const EMI = this.applicationService.getApplication() ? this.applicationService.getApplication().TotalInstallmentAmount : '';
    const  originChannel = this.tokenService.getCheckoutParams() ? this.tokenService.getCheckoutParams().flowType : (this.widgetFlow ? Channel.widget : Channel.default);
    const props = {
      MerchantName,
      Amount,
      Tenure,
      EMI,
      originChannel
    };
    return props;
  }
}
